const clientSourceOptions = [
  {
    id: 1,
    textDropDownEn: "-- Choose --",
  },
  {
    id: 2,
    textDropDownEn: "Contact Form",
  },
  {
    id: 3,
    textDropDownEn: "Facebook Chat",
  },
  {
    id: 4,
    textDropDownEn: "Google My Business Chat",
  },
  {
    id: 5,
    textDropDownEn: "Info Kit Download",
  },
  {
    id: 6,
    textDropDownEn: "Instagram Chat",
  },
  {
    id: 7,
    textDropDownEn: "Paid Ads (Bing)",
  },
  {
    id: 8,
    textDropDownEn: "Paid Ads (Google)",
  },
  {
    id: 9,
    textDropDownEn: "Paid Ads (King Kong)",
  },
  {
    id: 10,
    textDropDownEn: "Phone Call",
  },
  {
    id: 11,
    textDropDownEn: "Referral",
  },
  {
    id: 12,
    textDropDownEn: "Referral (RMS)",
  },
  {
    id: 13,
    textDropDownEn: "Referral (Sana)",
  },
  {
    id: 14,
    textDropDownEn: "Website Chat",
  },
  {
    id: 15,
    textDropDownEn: "WhatsApp",
  },
];

export default clientSourceOptions;
